import EnrollPhone from "./EnrollPhone";
import LoginPhone from "./LoginPhone";
import PuzzlePhone from "../Games/Puzzle/PuzzlePhone";

export default function ContainPhone(props) {
    const ContainInfo = props.ContainInfo;

    if (ContainInfo==="Enroll"){
        return (
        <div>
            <EnrollPhone />
        </div>
        );
    }else if (ContainInfo==="Login"){
        return (
        <div>
            <LoginPhone />
        </div>
        );
    }else if (ContainInfo==="Puzzle"){
        return (
        <div>
            <PuzzlePhone />
        </div>
        );
    } 
}